import { render, staticRenderFns } from "./HistoryProblem.vue?vue&type=template&id=3ae44078"
import script from "./HistoryProblem.vue?vue&type=script&lang=ts"
export * from "./HistoryProblem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports